export default {"src":"/_next/static/media/Logo_Gases_Two_lines.224a4155.svg","height":56,"width":129,"blurWidth":0,"blurHeight":0};